import styled, { css, DefaultTheme } from 'styled-components';
import { shade } from '../../styles/theme';

/**
 * Paleta da página de local derivada das cores do tenant: na iLaura,
 * primary = bege/dourado e secondary = marrom. "ink" é o preto quente da
 * marca, "goldText" é o dourado escurecido para ter contraste sobre branco.
 */
export const ink = (theme: DefaultTheme) => shade(theme.colors.secondary, -0.6);
export const goldText = (theme: DefaultTheme) => shade(theme.colors.primary, -0.42);
export const sand = (theme: DefaultTheme) => shade(theme.colors.primary, 0.86);
export const hairline = (theme: DefaultTheme) => shade(theme.colors.primary, 0.55);

export const Eyebrow = styled.span<{ $onDark?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${({ theme, $onDark }) => ($onDark ? theme.colors.primary : goldText(theme))};

  &::before {
    content: '';
    width: 28px;
    height: 1px;
    background: currentColor;
  }
`;

export const SectionHeading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 600;
  font-size: clamp(1.7rem, 3.2vw, 2.5rem);
  line-height: 1.12;
  letter-spacing: -0.025em;
  color: ${({ theme }) => ink(theme)};
  margin-top: 0.9rem;
`;

const bandSpacing = css`
  padding: clamp(3.5rem, 7vw, 6rem) 0;
  scroll-margin-top: 5.5rem;
`;

export const Band = styled.section`
  ${bandSpacing}

  /* Duas faixas brancas seguidas não somam o respiro. */
  & + & {
    padding-top: 0;
  }
`;

export const SandBand = styled.section`
  ${bandSpacing}
  background: ${({ theme }) => sand(theme)};
`;

export const actionBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 52px;
  padding: 0 1.6rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.98rem;
  letter-spacing: 0.01em;
  transition: transform 0.18s ease, background 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease;
  white-space: nowrap;

  &:hover { transform: translateY(-1px); }
  &:active { transform: translateY(0); }
`;
